const Hero = ({ scrollToChat }) => {
  return (
    <section className="pt-24 pb-32 px-4 container mx-auto">
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-10 flex justify-center">
          <div className="relative">
            <div className="w-24 h-24 rounded-full overflow-hidden border border-gray-200 dark:border-gray-700">
              <img
                src="/images/alex_avatar.png"
                alt="Alex"
                className="w-full h-full object-cover"
                loading="eager"
                width="96"
                height="96"
              />
            </div>
          </div>
        </div>

        <h2 className="text-2xl font-bold mb-1 font-['Inter']">
          <span className="gradient-text">Hey I'm Alex!</span>{" "}
          <span className="wave-emoji">👋</span>
        </h2>
        <h1 className="text-3xl font-medium mb-2 text-gray-900 dark:text-gray-100">
          A builder and investor<br/><span className="font-light  ">based in  </span>
          <span className="font-light italic border-b-2 border-gray-200 dark:border-gray-700 pb-1"> 
             London
          </span>
          <span>📍 </span>
          <span className="font-light  "> exploring</span>
        </h1>
        <div className="text-3xl mb-2 text-gray-900 dark:text-gray-100 inline-flex flex-wrap justify-center items-center gap-2">
         
      
          <span className="inline-flex items-center">
            
            <span className="text-flip-container bg-gray-200 dark:bg-gray-800 px-4 py-1 rounded-md ml-2">
              <span className="text-flip font-light italic inline-block">
                <span className="text-flip-item">ideas</span>
                <span className="text-flip-item">AI Applications</span>
                <span className="text-flip-item">the Future of Work</span>
                <span className="text-flip-item">FinTech</span>
              </span>
            </span>
          </span>
        </div>

        <div className="h-8"></div>

        <div className="flex justify-center space-x-6 mb-8">
          <a
            href="mailto:alex@designr.co"
            className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <i className="far fa-envelope text-lg"></i>
            <span className="sr-only">Email</span>
          </a>
          <a
            href="https://www.linkedin.com/in/alex-s-0a1692117/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <i className="fab fa-linkedin-in text-lg"></i>
            <span className="sr-only">LinkedIn</span>
          </a>
          <a
            href="https://x.com/alstras"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <i className="fab fa-x-twitter text-lg"></i>
            <span className="sr-only">X</span>
          </a>
          <a
            href="https://dribbble.com/designrco"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 transition-colors dribbble-tag-container"
          >
            <i className="fab fa-dribbble text-lg"></i>
            <span className="sr-only">Dribbble</span>
          </a>
          <a
            href="https://www.producthunt.com/@alstras"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-900 dark:text-gray-100 hover:text-gray-600 dark:hover:text-gray-300 transition-colors dribbble-tag-container"
          >
            <i className="fab fa-product-hunt text-lg"></i>
            <span className="sr-only">Product Hunt</span>
          </a>
        </div>

        <div className="mt-12">
          <button
            onClick={scrollToChat}
            className="inline-flex items-center px-6 py-3 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-full text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400 shadow-sm transition-colors"
          >
            Find Out More About Me <i className="fas fa-arrow-down ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
